import { render, staticRenderFns } from "./RegisterPersonalStep.vue?vue&type=template&id=a22d9e58&"
import script from "./RegisterPersonalStep.vue?vue&type=script&lang=js&"
export * from "./RegisterPersonalStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports